export default __webpack_public_path__ + "static/media/expl-dissect_07_DE.6aae7684.png";